import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from './base-query';

const configAPI = createApi({
    reducerPath: "configAPI",
    baseQuery,
    endpoints: (builder) => ({
        getAllBanners: builder.mutation({
            query: ({ page, size, key }) => {
                let apiUrl = `admin/banner?page=${page}&limit=${size}`;

                if (key) {
                    apiUrl += `&search=${key}`;
                }

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
            providesTags: ["banners"],
        }),
        getSpecificBannerDetails: builder.mutation({
            query: ({ id }) => {
                let apiUrl = `admin/banner/${id}`;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response
        }),
        createBanner: builder.mutation({
            query: ({ data }) => {
                return {
                    url: "admin/banner",
                    method: "POST",
                    body: data
                };
            },
            invalidatesTags: ["banners"],
        }),
        updateBanner: builder.mutation({
            query: ({ data }) => {
                return {
                    url: `admin/banner`,
                    method: "PUT",
                    body: data
                };
            },
            invalidatesTags: ["banners"],
        }),
        deleteBanner: builder.mutation({
            query: ({ id }) => {
                return {
                    url: `admin/banner/${id}`,
                    method: "DELETE"
                };
            },
            invalidatesTags: ["banners"],
        }),

        updateFeaturedProduct: builder.mutation({
            query: ({ data }) => {
                return {
                    url: `admin/product/featured`,
                    method: "PUT",
                    body: data
                };
            }
        }),
    })
});

export const { 
    useGetAllBannersMutation,
    useGetSpecificBannerDetailsMutation,
    useCreateBannerMutation,
    useUpdateBannerMutation,
    useDeleteBannerMutation,

    useUpdateFeaturedProductMutation
} = configAPI;

export default configAPI;